module.exports = "/_next/static/images/kisurin-appearance-17424182889c2b0378d4324548536505.png";